module.exports = __webpack_public_path__ + "static/media/venue_location_icon.2ceaf661.svg";